import uz from "@/i18n/uz.json"
import ru from "@/i18n/ru.json"
import en from "@/i18n/en.json"

export type Locale = "uz" | "ru" | "en"

const translations = {
  uz,
  ru,
  en,
}

export function getTranslation(locale: Locale) {
  return translations[locale] || translations.uz
}

export function getAvailableLocales(): Locale[] {
  return ["uz", "ru", "en"]
}
